import _objectSpread from "/Users/safepal/Desktop/work/spd/feedback-console/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import { defineComponent, reactive, watch } from 'vue';
import Alert from "./Alert.vue";
import TipsLoading from "./Loading.vue";
import TipsError from "./showError.vue";
import TipsConfirm from "./Confirm.vue";
import TipsSuccess from "./SuccessToast.vue";
import TipsToast from "./Toast.vue";

function emptyFn() {}

function mergeToTar(tar, opt) {
  if (!opt) {
    return;
  }

  Object.keys(tar).forEach(function (prop) {
    if (Object.prototype.hasOwnProperty.call(opt, prop)) {
      tar[prop] = opt[prop];
    }
  });
}

export default defineComponent({
  name: "Tips",
  components: {
    "tips-alert": Alert,
    "tips-loading": TipsLoading,
    "tips-error": TipsError,
    "tips-confirm": TipsConfirm,
    "tips-success": TipsSuccess,
    "tips-toast": TipsToast
  },
  setup: function setup() {
    var loading = reactive({
      show: false
    });
    var alert = reactive({
      show: false,
      text: "",
      buttonText: undefined,
      isShowStatus: false,
      status: true,
      close: emptyFn,
      confirm: emptyFn
    });
    var err = reactive({
      show: false,
      text: ""
    });
    var confirm = reactive({
      show: false,
      text: "",
      options: undefined,
      confirm: emptyFn,
      cancel: emptyFn
    });
    var success = reactive({
      show: false,
      text: "",
      callback: emptyFn
    });
    var toast = reactive({
      count: 0,

      /** @type{{text:String, show:Boolean, count: Number ,useTransition: Boolean}[]}*/
      list: []
    });
    watch(function () {
      return alert.show;
    }, function (val) {
      if (!val) {
        alert.close && alert.close();
      }
    });

    var showAlert = function showAlert(options) {
      mergeToTar(alert, options);
      alert.show = true;
    };

    var showLoading = function showLoading() {
      loading.show = true;
    };

    var removeLoading = function removeLoading() {
      loading.show = false;
    };

    var showError = function showError(options) {
      mergeToTar(err, options);
    };

    var showConfirm = function showConfirm(options) {
      mergeToTar(confirm, options);
      confirm.show = true;

      if (!options.confirm) {
        return new Promise(function (resolve) {
          confirm.confirm = function () {
            return resolve();
          };
        });
      }
    };
    /**
     *  @param {{callback:Function,text:String}} options
     */


    var showSuccess = function showSuccess(options) {
      mergeToTar(success, options);
      success.show = true;

      if (!options.callback) {
        return new Promise(function (resolve) {
          success.callback = function () {
            return resolve();
          };
        });
      }
    };
    /**
     *  @param {{text:String, useTransition: Boolean | undefined}} options
     */


    var showToast = function showToast(options) {
      toast.list.push(_objectSpread(_objectSpread({
        useTransition: true
      }, options), {}, {
        show: true,
        count: toast.count++
      }));
      return toast.count;
    };

    return {
      loading: loading,
      alert: alert,
      err: err,
      confirm: confirm,
      success: success,
      toast: toast,
      showAlert: showAlert,
      showLoading: showLoading,
      removeLoading: removeLoading,
      showError: showError,
      showConfirm: showConfirm,
      showSuccess: showSuccess,
      showToast: showToast
    };
  }
});